import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const RegisterScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [group, setGroup] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  
  const navigate = useNavigate();

  const registerHandler = async (e) => {
    e.preventDefault();

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    if ( password !== confirmPassword ) {
      setPassword("");
      setConfirmPassword("");
      window.alert("Passwords do not match.");
      return;
    }

    if ( password.length < 6 ) {
      setPassword("");
      setConfirmPassword("");
      window.alert("Password must be at least 6 characters long.");
      return;
    }

    if ( fullName.length === 0 ) {
      window.alert("Please provide a full name.");
      return;
    }

    if ( group.length === 0 ) {
      window.alert("Please specify the group that you belong to, or represent.");
      return;
    }

    axios.post(
      "/auth/register",
      {
        email,
        fullName,
        group,
        password
      },
      config
    ).then(
      () => {
        window.alert("Registration successful, please check your email to verify your email address and then login.");
        navigate("/login");
      }
    ).catch(
      ( error ) => {
        console.log(error);
      }
    );
  };

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={9} lg={7}>
          <Card className="auth-card">
            <Card.Body>
              <Form onSubmit={registerHandler}>
                <h3 className="page-title">Register New Account</h3>
                <p className="page-subtitle mb-4">Create your personal account to access courses and bookings.</p>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} tabIndex={1}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formFullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control required placeholder="Full name" value={fullName} onChange={(e) => setFullName(e.target.value)} tabIndex={2}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formGroup">
                  <Form.Label>Group</Form.Label>
                  <Form.Select value={group} onChange={(e) => setGroup(e.target.value)} tabIndex={3}>
                    <option value="">Please select the group that you belong to, or represent</option>
                    <option value="Student">Student</option>
                    <option value="Agent">Agent</option>
                    <option value="School">School</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" required autoComplete="true" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={4}/>
                </Form.Group>
                <Form.Group className="mb-4" controlId="formConfirmPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control type="password" required autoComplete="true" placeholder="Confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} tabIndex={5}/>
                </Form.Group>
                <Button variant="primary" type="submit" tabIndex={6}>
                  Register
                </Button>

                <Form.Text className="auth-links" muted>
                  Already have an account? <Link to="/login" tabIndex={7}>Login</Link>
                </Form.Text>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterScreen;
